@if (
  selectedRole &&
  authService.isAuthorized([PermissionsEnum.Settings_team_role_view])
) {
  <app-role-information
    (close)="selectedRole=undefined"
    [id]="selectedRole.id!"
  ></app-role-information>
}
<div class="subpage-container">
  <div class="container g-0 m-0">
    <div
      class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2"
    >
      <app-search
        placeholder="{{ 'TEAM_SEARCHBY' | translate }}"
        (searchChange)="searchChange($event)"
      >
      </app-search>
    </div>
    <div class="row g-0 m-0 pt-2 p-4 gap-2 ps-5 pe-5">
      <div
        *ngFor="let row of data; let i = index"
        class="row g-0 p-0 d-flex justify-content-between member-info p-3"
      >
        <div
          class="col d-flex p-0 justify-content-start align-items-center"
          (click)="handleRowClick(row)"
        >
          <span class="item-title pe-3">{{ row.name }}</span>
        </div>
        <div
          class="col-auto p-0 subtitle d-flex justify-content-end align-items-center text"
        >
          <span
            >{{ "CREATEDBY" | translate }} {{ row.createdByUserEmail }}</span
          >
          <svg-icon alt="Dot" src="assets/settings/dot.svg" class="ps-2 pe-2"></svg-icon>
          <span class="pe-2"
            >{{ "DATECREATED" | translate }} 
            {{ row.createdTime | date: "d MMMM, y" }}</span
          >
          <span
            class="status"
            [ngClass]="{
              active: row.status === 'Active',
              pending: row.status === 'Pending',
              inactive: row.status === 'Inactive',
            }"
            >{{ row.status }}</span
          >
          <svg-icon 
          alt="More"
            class="more-icon ps-1"
            src="assets/settings/more-icon.svg"
            (click)="setActiveRow(i)"
          ></svg-icon>
          <!-- Dropdown -->
          @if (
            authService.isAuthorized([
              PermissionsEnum.Settings_team_role_modify,
            ])
          ) {
            <div *ngIf="activeRow === i" class="positioning">
              <div class="overlay-light" (click)="setActiveRow(null)"></div>
              <div class="dropdown-button p-2">
                <div class="dropdown-button-menu p-0 m-0">
                  <div
                    class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                    (click)="edit(row.id!)"
                  >
                    <svg-icon alt="Edit" src="assets/device/edit.svg"></svg-icon>
                    <span class="ps-2 item-title">{{
                      "EDITROLE" | translate
                    }}</span>
                  </div>

                  @if (
                    !(row.status === "Inactive") &&
                    authService.isAuthorized([
                      PermissionsEnum.Settings_team_role_modify,
                    ])
                  ) {
                    <div
                      class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                      (click)="changeStatus(row.id!, RoleStatus.Inactive)"
                    >
                      <svg-icon alt="Deactivate" src="assets/settings/deactivate.svg"></svg-icon>
                      <span class="ps-2 item-title">
                        {{ "DEACTIVATE" | translate }}
                      </span>
                    </div>
                  }
                  
                  @if (
                    row.status === "Inactive" &&
                    authService.isAuthorized([
                      PermissionsEnum.Settings_team_role_modify,
                    ])
                  ) {
                    <div
                      class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                      (click)="changeStatus(row.id!, RoleStatus.Active)"
                    >
                      <svg-icon
                      alt="Activate"
                        class="pb-1"
                        src="assets/settings/activate.svg"
                      ></svg-icon>
                      <span class="ps-2 item-title">
                        {{ "ACTIVATE" | translate }}
                      </span>
                    </div>
                  }
                  
                  @if (
                    authService.isAuthorized([
                      PermissionsEnum.Settings_team_role_delete,
                    ])
                  ) {
                    <div
                      class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                      (click)="isModalOpen = true; selectedRowId = row.id!; setActiveRow(null)"
                    >
                      <svg-icon
                      alt="Trash Can"
                        src="assets/settings/trash-can-red.svg"
                      ></svg-icon>
                      <span class="ps-2 item-title red">
                        {{ "DELETE" | translate }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfRoles"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    >
    </app-pagination>
  </div>
</div>

<app-confirm-dialog *ngIf="isModalOpen" titleKey="DELETE" question="ROLE_DELETE"
  (confirm)="delete(selectedRowId!)" (cancel)="isModalOpen = false; activeRow = null"></app-confirm-dialog>
